import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"; 
import { useDispatch } from "react-redux"; 
import { updateFirstRun } from "../../actions/firstRunAction";
import { getAllNotification } from "../../actions/notificationAction";
import queryString from "query-string";
import { getWidgetWallData } from "../../actions/wallDataAction";
import { getProductAndPlanDetails } from "../../actions/product_details_action";
import { getUserInfo } from "../../actions/loginActions";
import LoadingScreen from "../CommonComponents/LoadingScreen";
import { getWallFeeds } from "../../actions/analyticsAction";


let request = true;
function RedirectLogin() {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const parsed = queryString.parse(window.location.search);

    useEffect(() => {
        const token = atob(params.token);

            if(request){
                request = false;
                localStorage.setItem('access_token',token);
                localStorage.setItem('sessionToken',params.sessionToken);
                console.log("1",request);
                if(params.admin){
                   localStorage.setItem('Isadmin',params.admin)
                }
        
                setTimeout(()=>{
                    dispatch(getUserInfo(navigate,true,true,true,() => {
                        if(parsed && Object.keys(parsed).length > 0 && parsed.redirect){
                            const redirectUrl = parsed.redirect;
                            const action = parsed.action;
                            if(action && action == 'create'){
                                setTimeout(() => navigate(`${redirectUrl}?plugin`), 100);
                            }else{
                                const routes = redirectUrl.split('/');
                                const wallId = routes[routes.length - 1];
                                dispatch(getWidgetWallData(localStorage.getItem('ownerId'), wallId, ()=> navigate(redirectUrl)));
                            }
                        }
                        setTimeout(()=>{
                            dispatch(getWallFeeds(localStorage.getItem('ownerId')));
                        },500)
                        dispatch(getAllNotification({ type: "latest", synced: 0, created: "", page: 0, perPage: 10, sortby:"message",direction:"ASC" }, true));
                        dispatch(getProductAndPlanDetails());
                        dispatch(updateFirstRun(false));
                    }));
                },100)
            }
            
    },[])


    return <LoadingScreen />
}

export default RedirectLogin;